import axios from 'axios'

export default {
    getMenu: (type) => axios.get('menu/'+type),
    getParameters: () => axios.get('parameters'),
    isCollaborator: () => axios.get('collaborator/check'),
}